import { render, staticRenderFns } from "./AxProjectThumbnail.vue?vue&type=template&id=0a8be669&scoped=true&"
import script from "./AxProjectThumbnail.vue?vue&type=script&lang=ts&"
export * from "./AxProjectThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./AxProjectThumbnail.vue?vue&type=style&index=0&id=0a8be669&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8be669",
  null
  
)

export default component.exports